import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { AnalyticsService } from 'src/app/_services';

@Component({
  selector: 'app-repaymentsnapshot',
  templateUrl: './repaymentsnapshot.component.html',
  styleUrls: ['./repaymentsnapshot.component.css']
})
export class RepaymentsnapshotComponent implements OnInit {

  @Input('showperformance') showperformance = 'no';
  @Input('currentUser') currentUser: any;
  loading = true;
  platform_summary: any;

  constructor(private analytics: AnalyticsService) {}

  ngOnInit() {
    this.getPerformanceSnapshot();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];
      let curVal = JSON.stringify(change.currentValue);
      let prevVal = JSON.stringify(change.previousValue);
    }
  }

  getPerformanceSnapshot() {
    this.loading = true;
    this.analytics.runRepaymentSnapshot(this.currentUser.token)
      .subscribe(data => {
        this.loading = false;
        this.platform_summary = data;
      });
  }
}

